import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3553aa3d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "reward-box"
};
const _hoisted_2 = {
  class: "reward-tit"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 退款提示 ");
const _hoisted_4 = {
  class: "reward-info"
};
const _hoisted_5 = {
  class: "info-top-box"
};
const _hoisted_6 = {
  class: "info-top"
};
const _hoisted_7 = {
  class: "tips"
};
const _hoisted_8 = {
  class: "ul-tit"
};
const _hoisted_9 = {
  class: "ul"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "p"
};
const _hoisted_12 = {
  class: "p"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "righticon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "icon"
})], -1));
const _hoisted_14 = {
  class: "reward-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompPopupBottom = _resolveComponent("CompPopupBottom");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_CompPopupBottom, {
    show: $props.show,
    type: "reward"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePopup && $options.closePopup(...args))
    })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($props.info.refund_msg), 1), _createElementVNode("div", _hoisted_8, _toDisplayString($props.info.order_msg), 1), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.info.list, (item, idx) => {
      return _openBlock(), _createElementBlock("div", {
        class: "li",
        key: idx,
        onClick: $event => $options.goOrderDetails(item.order_id)
      }, [_createElementVNode("div", _hoisted_11, "加购档：" + _toDisplayString(item.reward_title), 1), _createElementVNode("div", _hoisted_12, "待退款 ¥" + _toDisplayString(item.amount), 1), _hoisted_13], 8, _hoisted_10);
    }), 128))])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
      class: "btn",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.closePopup && $options.closePopup(...args))
    }, "取消"), _createElementVNode("div", {
      class: "btn",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.goNext && $options.goNext(...args))
    }, "继续申请退款")])])])]),
    _: 1
  }, 8, ["show"])]);
}